<ng-container *ngIf="this['dialogRef'] else card">

  <div mat-dialog-title class="dialog-title p-3 pr-5">
    <h5>{{ utils.getLangTerm('safety-plans.singular', 'Safety Plan') }} Document</h5>
    <button mat-icon-button aria-label="Close dialog" matTooltip="Close this dialog." mat-dialog-close
      class="dialog-close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 pt-4 pb-0">
    <form #f="ngForm" (ngSubmit)="onSave(f)">
      <div class="container-fluid">
        <div class="row">
          <div class="col">
            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Document Type</mat-label>
              <mat-select [(ngModel)]="sssp_doc.doc_type" name="doc_type" aria-label="Select the type of this document.">
                <mat-option value="Hazard Register">Hazards & Risks Register</mat-option>
                <mat-option value="{{ utils.getLangTerm('hazardous-substances.list.site-title', 'Hazardous Substances') }}">{{ utils.getLangTerm('hazardous-substances.list.site-title', 'Hazardous Substances') }}</mat-option>
                <mat-option value="{{ utils.getLangTerm('task_analysis_documents.list.title', 'Task Analysis') }}">{{ utils.getLangTerm('task_analysis_documents.list.title', 'Task Analysis') }}</mat-option>
                <mat-option value="Training-Competency Register">Training/Competency Register</mat-option>
                <mat-option [value]="utils.getLangTerm('toolbox-talks.plural', 'Toolbox Talks')">{{ utils.getLangTerm('toolbox-talks.plural', 'Toolbox Talks') }}</mat-option>
                <mat-option value="Emergency Response Plan">Emergency Response Plan</mat-option>
                <mat-option value="Incident Register">Incident Register</mat-option>
                <mat-option value="Induction">Induction</mat-option>
                <mat-option value="{{ utils.getLangTerm('safety-plans.singular', 'Safety Plan') }}">{{ utils.getLangTerm('safety-plans.singular', 'Safety Plan') }}</mat-option>
                <mat-option value="Other">Other</mat-option>
              </mat-select>
            </mat-form-field>

            <app-timezone-select [timezoneInput]="selectedTimezone"
              (timezoneOutput)="getOutputTimezone($event)"></app-timezone-select>

            <app-datetime-picker [selectedDateTime]="expiresAtDateTime" [pickerName]="'expiresAtDateTime'"
              [label]="'Expiry Date'" [hint]="'Click the calendar icon to select a date and time.'"
              [selectTooltip]="'Select the expiry date.'" [removeTooltip]="'Remove the expiry date.'"
              [classes]="'full-width mb-4'"
              (pickerDetailsOutput)="getOutputDateTimeDetails($event)"></app-datetime-picker>
          </div>

          <div class="col" *ngIf="sssp.account_id == app.account.id else showStatusAndComments">
            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Status</mat-label>
              <mat-select [(ngModel)]="sssp_doc.doc_status" name="doc_status"
                aria-label="Select the status of this document.">
                <mat-option value="required">Required</mat-option>
                <mat-option value="submitted">Submitted</mat-option>
                <mat-option value="in review">In Review</mat-option>
                <mat-option value="accepted">Accepted</mat-option>
                <mat-option value="rejected">Rejected</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Comments</mat-label>
              <input matInput placeholder="Please enter some comments here." [(ngModel)]="sssp_doc.doc_comments"
                name="doc_comments" type="text" />
              <mat-hint>
                Enter some comments for this document.
              </mat-hint>
            </mat-form-field>
          </div>

          <ng-template #showStatusAndComments>
            <div class="col" *ngIf="sssp_doc.id">
              <div class="row">
                <h6>Status</h6>
              </div>
              <div class="row">
                <p>{{ sssp_doc.doc_status | titlecase }}</p>
              </div>

              <div class="row">
                <h6>Comments</h6>
              </div>
              <div class="row">
                <p>{{ sssp_doc.doc_comments }}</p>
              </div>
            </div>
          </ng-template>

          <div class="col">
            <div class="px-3 pt-0 pb-4">
              <ng-container>
                <div class="row">
                  <h6>Rating</h6>
                </div>
                <div class="row">
                  <app-rating [rating]="sssp_doc.doc_rating" [edit]="sssp.account_id == app.account.id"
                    (ratingChanged)="sssp_doc.doc_rating = $event"></app-rating>
                </div>
                <div class="row">
                  <p *ngIf="sssp_doc.sssp.account_id != app.account.id">
                    <small>The rating can only be changed by PCBU1s.</small>
                  </p>
                </div>
              </ng-container>

              <div class="row">
                <h6>Uploaded Files</h6>
              </div>
              <div class="row">
                <ng-container *ngIf="sssp_doc.files && sssp_doc.files.length > 0 else noFiles">
                  <span class="badge badge-pill badge-secondary m-1" style="cursor: pointer;"
                    *ngFor="let file of sssp_doc.files"
                    (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)">
                    {{ file.name }}
                  </span>
                </ng-container>
                <ng-template #noFiles>
                  <mat-hint>There are no uploaded files to show.</mat-hint>
                </ng-template>
              </div>
            </div>
          </div>

        </div>
      </div>
    </form>
  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="px-3 py-2">
    <button mat-raised-button class="my-2 ml-1 mr-2" type="button" color="primary" (click)="onSave(f)"
      matTooltip="Save this document.">
      <mat-icon>save</mat-icon>
      Save
    </button>

    <app-file-browse-button parentObjectType="sssp_doc" [parentObjectId]="sssp_doc.id"
      [filesCount]="sssp_doc.files.length" (selectedFiles)="onSelectFiles($event)"
      (afterDialogClosedEvent)="onSaveAndRefresh(f)">
    </app-file-browse-button>

    <button mat-raised-button class="my-2 ml-1 mr-2" type="button" color="secondary"
      *ngIf="sssp.account_id == app.account.id && sssp.contractor_id"
      (click)="onComposeNewMessage(sssp.contractor_id, f)"
      matTooltip="Click this button to send a message to this {{ utils.getLangTerm('contractors.singular', 'Contractor') }}.">
      <mat-icon>send</mat-icon>
      Send Message
    </button>

    <button mat-icon-button class="dialog-remove-button my-2 ml-auto mr-1" type="button" color="warn"
      (click)="onDeleteSSSPDoc($event)" *ngIf="sssp_doc.id" matTooltip="Delete this document.">
      <mat-icon>delete</mat-icon>
    </button>
  </mat-dialog-actions>
</ng-container>

<ng-template #card>
  <form #f="ngForm" (ngSubmit)="onSave(f)">
    <mat-card appearance="outlined" class="m-3">
      <form #f="ngForm" (ngSubmit)="onSave(f)">
        <mat-card-content class="px-3 pt-4 pb-0">
          <div class="container-fluid">
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Document Type</mat-label>
                  <mat-select [(ngModel)]="sssp_doc.doc_type" name="doc_type"
                    aria-label="Select the type of this document.">
                    <mat-option value="Hazard Register">Hazards & Risks Register</mat-option>
                    <mat-option value="{{ utils.getLangTerm('hazardous-substances.list.site-title', 'Hazardous Substances') }}">{{ utils.getLangTerm('hazardous-substances.list.site-title', 'Hazardous Substances') }}</mat-option>
                    <mat-option value="{{ utils.getLangTerm('task_analysis_documents.list.title', 'Task Analysis') }}">{{ utils.getLangTerm('task_analysis_documents.list.title', 'Task Analysis') }}</mat-option>
                    <mat-option value="Training-Competency Register">Training/Competency Register</mat-option>
                    <mat-option [value]="utils.getLangTerm('toolbox-talks.plural', 'Toolbox Talks')">{{ utils.getLangTerm('toolbox-talks.plural', 'Toolbox Talks') }}</mat-option>
                    <mat-option value="Emergency Response Plan">Emergency Response Plan</mat-option>
                    <mat-option value="Incident Register">Incident Register</mat-option>
                    <mat-option value="Induction">Induction</mat-option>
                    <mat-option value="{{ utils.getLangTerm('safety-plans.singular', 'Safety Plan') }}">{{ utils.getLangTerm('safety-plans.singular', 'Safety Plan') }}</mat-option>
                    <mat-option value="Other">Other</mat-option>
                  </mat-select>
                </mat-form-field>

                <app-timezone-select [timezoneInput]="selectedTimezone"
                  (timezoneOutput)="getOutputTimezone($event)"></app-timezone-select>

                <app-datetime-picker [selectedDateTime]="expiresAtDateTime" [pickerName]="'expiresAtDateTime'"
                  [label]="'Expiry Date'" [hint]="'Click the calendar icon to select a date and time.'"
                  [selectTooltip]="'Select the expiry date.'" [removeTooltip]="'Remove the expiry date.'"
                  [classes]="'full-width mb-4'"
                  (pickerDetailsOutput)="getOutputDateTimeDetails($event)"></app-datetime-picker>
              </div>

              <div class="col" *ngIf="sssp.account_id == app.account.id else showStatusAndComments">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Status</mat-label>
                  <mat-select [(ngModel)]="sssp_doc.doc_status" name="doc_status"
                    aria-label="Select the status of this document.">
                    <mat-option value="required">Required</mat-option>
                    <mat-option value="submitted">Submitted</mat-option>
                    <mat-option value="in review">In Review</mat-option>
                    <mat-option value="accepted">Accepted</mat-option>
                    <mat-option value="rejected">Rejected</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Comments</mat-label>
                  <input matInput placeholder="Please enter some comments here." [(ngModel)]="sssp_doc.doc_comments"
                    name="doc_comments" type="text" />
                  <mat-hint>
                    Enter some comments for this document.
                  </mat-hint>
                </mat-form-field>
              </div>

              <ng-template #showStatusAndComments>
                <div class="col" *ngIf="sssp_doc.id">
                  <div class="row">
                    <h6>Status</h6>
                  </div>
                  <div class="row">
                    <p>{{ sssp_doc.doc_status | titlecase }}</p>
                  </div>

                  <div class="row">
                    <h6>Comments</h6>
                  </div>
                  <div class="row">
                    <p>{{ sssp_doc.doc_comments }}</p>
                  </div>
                </div>
              </ng-template>

              <div class="col">
                <div class="px-3 pt-0 pb-4">
                  <ng-container>
                    <div class="row">
                      <h6>Rating</h6>
                    </div>
                    <div class="row">
                      <app-rating [rating]="sssp_doc.doc_rating" [edit]="sssp.account_id == app.account.id"
                        (ratingChanged)="sssp_doc.doc_rating = $event"></app-rating>
                    </div>
                    <div class="row">
                      <p *ngIf="sssp_doc.sssp.account_id != app.account.id">
                        <small>The rating can only be changed by PCBU1s.</small>
                      </p>
                    </div>
                  </ng-container>

                  <div class="row">
                    <h6>Uploaded Files</h6>
                  </div>
                  <div class="row">
                    <ng-container *ngIf="sssp_doc.files && sssp_doc.files.length > 0 else noFiles">
                      <span class="badge badge-pill badge-secondary m-1" style="cursor: pointer;"
                        *ngFor="let file of sssp_doc.files"
                        (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)">
                        {{ file.name }}
                      </span>
                    </ng-container>
                    <ng-template #noFiles>
                      <mat-hint>There are no uploaded files to show.</mat-hint>
                    </ng-template>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </mat-card-content>

        <hr class="m-0 p-0">

        <mat-card-actions class="d-flex flex-wrap px-3 py-2">
          <button mat-raised-button class="my-2 ml-1 mr-2" type="button" color="primary" (click)="onSave(f)"
            matTooltip="Save this document.">
            <mat-icon>save</mat-icon>
            Save
          </button>

          <app-file-browse-button parentObjectType="sssp_doc" [parentObjectId]="sssp_doc.id"
            [filesCount]="sssp_doc.files.length" (selectedFiles)="onSelectFiles($event)"
            (afterDialogClosedEvent)="onSaveAndRefresh(f)">
          </app-file-browse-button>

          <button mat-raised-button class="my-2 ml-1 mr-2" type="button" color="secondary"
            *ngIf="sssp.account_id == app.account.id && sssp.contractor_id"
            (click)="onComposeNewMessage(sssp.contractor_id, f)"
            matTooltip="Click this button to send a message to this {{ utils.getLangTerm('contractors.singular', 'Contractor') }}.">
            <mat-icon>send</mat-icon>
            Send Message
          </button>

          <button mat-icon-button class="dialog-remove-button my-2 ml-auto mr-1" type="button" color="warn"
            (click)="onDeleteSSSPDoc($event)" *ngIf="sssp_doc.id" matTooltip="Delete this document.">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-card-actions>

      </form>
    </mat-card>
  </form>
</ng-template>
